<template>
  <div v-if="$route.name === 'scalapay-result'" class="scalapay-view">
    <router-view />
  </div>

  <div class="app" v-else>
    <a-layout>
      <a-layout-header class="border-b-2 navbar">
        <div class="navbar-content-left">
          <img
            @click="goHome"
            src="https://www.insurance4music.eu/wp-content/themes/i4m/images/logo.png"
            class="logo"
            alt="Insurance4Music logo ufficiale"
            width="66"
          />
        </div>
        <div class="navbar-content-right">
          <a-badge v-if="!onMobile && isBroker" class="md:mr-2">
            <router-link :to="{ name: 'resellers' }" class="font-semibold">
              Rivenditori
            </router-link>
          </a-badge>

          <div
            v-if="!onMobile && !isBroker"
            class="font-semibold cursor-pointer hover:text-i4m-orange"
            @click="supportRequestShow"
          >
            Richiedi supporto
          </div>

          <a-badge v-if="!onMobile && isBroker" class="md:mr-4">
            <router-link :to="{ name: 'broker-orders' }" class="font-semibold">
              Ordini
            </router-link>
          </a-badge>

          <a-badge v-if="!onMobile" :dot="!!$store.state.authOrder" class="mr-4">
            <div
              class="font-semibold cursor-pointer hover:text-i4m-orange"
              @click="navigateAndClose('order-login')"
            >
              I miei ordini
            </div>
          </a-badge>

          <telephone-cta :mobile="onMobile"></telephone-cta>

          <div
            v-if="onMobile"
            class="pl-8 font-bold capitalize cursor-pointer text-i4m-orange"
            @click="toggleMenu"
          >
            Menu
          </div>
        </div>
      </a-layout-header>

      <a-drawer
        placement="top"
        :closable="true"
        @close="mobileDrawerOpened = false"
        :visible="mobileDrawerOpened"
        class="flex-col h-full"
        :height="250"
      >
        <div class="mt-12 font-semibold" @click="navigateAndClose('home')">
          Pagina iniziale
        </div>

        <div class="mt-8 font-semibold" @click="supportRequestShow">
          Richiedi supporto
        </div>

        <a-badge :dot="!!$store.state.authOrder">
          <div class="mt-8 font-semibold" @click="navigateAndClose('order-login')">
            I miei ordini
          </div>
        </a-badge>
      </a-drawer>

      <a-layout-content :style="layoutBackground">
        <router-view
          v-if="
            (!$store.state.gettingOrder && $store.state.order) ||
              (!$store.state.gettingAuthOrder && $store.state.authOrder) ||
              $route.name === 'home' ||
              brokerAreaRoutes.includes($route.name) ||
              otherPages.includes($route.name)
          "
        />
        <div class="flex items-center justify-center w-full pt-8" v-else><a-spin /></div>
      </a-layout-content>

      <a-layout-footer class="px-4 mt-10">
        <div class="flex flex-row text-xs md:justify-between">
          <div class="flex flex-col md:flex-row md:justify-between ">
            <span class="mr-6">© 2019 Insurance4Music</span>
            <a href="/privacy-policy/" target="_blank" class="mr-2">PRIVACY POLICY</a>
            |
            <a href="/terms-and-conditions/" target="_blank" class="ml-2">
              TERMINI E CONDIZIONI
            </a>
          </div>
          <div class="flex flex-col md:flex-row md:justify-between ">
            <span class="mr-6">RUI B000616198</span>
            <span class="mr-6">CF E PIVA IT10566580964</span>
            <span class="mr-6">POWERED BY PRAGMATICA</span>
          </div>
        </div>
      </a-layout-footer>
    </a-layout>
    <SupportRequest
      :supportVisibility="supportVisibility"
      :quotationId="quotationId"
      @onCloseSupport="onCloseSupport"
    ></SupportRequest>
  </div>
</template>

<script>
// @ is an alias to /src
import SupportRequest from '@/components/SupportRequest.vue';
import '@/components/icons';

const brokerAreaRoutes = [
  'broker-login',
  'broker-orders',
  'broker-order',
  'auth-order',
  'order-login',
  'resellers'
];

const otherPages = ['privacy-policy', 'terms-and-conditions'];

export default {
  name: 'app',
  data: function() {
    return {
      onMobile: this.$mq.below(576),
      onTablet: this.$mq.below(1000),
      supportVisibility: false,
      quotationId: null,
      brokerAreaRoutes,
      otherPages,
      mobileDrawerOpened: false
    };
  },
  components: {
    SupportRequest
  },
  async beforeMount() {
    this.$store.dispatch('getOrder');
    this.$store.dispatch('searchItems', null);
    this.$store.dispatch('getAuthOrder');
  },
  computed: {
    isBroker() {
      return this.$store.getters.isBrokerLoggedIn;
    },

    layoutBackground() {
      const routesWithBg = ['home', 'order-login'];

      return {
        backgroundImage: routesWithBg.includes(this.$route.name)
          ? `url(${require('@/assets/bg.jpeg')})`
          : 'none'
      };
    }
  },
  watch: {
    '$mq.resize': function() {
      this.onMobile = this.$mq.below(640);
      this.onTablet = this.$mq.below(1024);
    },
    '$store.state.gettingOrder': function(val, old) {
      const isBrokerRoute = this.$route.meta.isBroker;
      const isLoginPage = this.$route.name === 'order-login';
      const isPrivacyPolicyPage = this.$route.name === 'privacy-policy';
      const isTermsAndConditionsPage = this.$route.name === 'terms-and-conditions';
      const isEmailLoginPage = this.$route.name === 'auth-order';
      const noOrders = !this.$store.state.order && !this.$store.state.authOrder;

      if (
        !val &&
        old &&
        noOrders &&
        !isBrokerRoute &&
        !isLoginPage &&
        !isEmailLoginPage &&
        !isPrivacyPolicyPage &&
        !isTermsAndConditionsPage
      ) {
        if (
          this.$route.path !== '/' &&
          this.$route.name !== 'home' &&
          this.$route.name !== 'scalapay-result'
        )
          this.$router.push({ name: 'home' });
      }
    }

    // '$store.getters.currentStep': function() {
    //   if (this.$router.currentRoute.meta.isBroker) return;
    //   const nextStep = this.$store.getters.currentStep;
    //   console.log('nextStep', this.$route.name, nextStep);
    //   if (this.$route.name !== nextStep) {
    //     this.$router.push({ name: this.$store.getters.currentStep });
    //   }
    // }
  },
  methods: {
    navigateAndClose(routeName) {
      this.$router.push({ name: routeName });
      this.mobileDrawerOpened = false;
    },

    toggleMenu() {
      this.mobileDrawerOpened = !this.mobileDrawerOpened;
    },

    goHome() {
      if (this.$route.name !== 'home') this.$router.push('/');
    },

    supportRequestShow: function() {
      this.mobileDrawerOpened = false;
      this.supportVisibility = true;
    },

    onCloseSupport: function() {
      this.supportVisibility = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/variables.scss';

.app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.navbar {
  background: white;
  justify-content: space-between;
  display: flex;
  padding: 10px 60px;

  @media #{$xs} {
    padding: 10px;
  }
}

.logo {
  height: 100%;
  cursor: pointer;
  margin-right: 40px;
}

.navbar-content-left,
.navbar-content-right {
  display: flex;
  align-items: center;
}
.navbar-content-left,
.navbar-content-right {
  a,
  span {
    margin-left: 20px;
  }
}

.ant-layout {
  min-height: 100vh !important;
}

.ant-layout-content {
  flex: 1 0 auto;
}

.ant-layout-footer {
  flex-shrink: 0;
}
</style>
